import { SVGProps, Ref, forwardRef } from 'react';

export const BoltOutlinedSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M4.584 4.88 3.538 6.5C2.336 8.362 1.735 9.294 2.112 10.01c.378.717 1.47.717 3.652.717h.76c.01 2.967.1 4.476.95 4.737.95.292 1.947-1.254 3.942-4.345l1.046-1.62c1.202-1.862 1.803-2.794 1.426-3.511-.378-.717-1.47-.717-3.652-.717h-.76c-.01-2.967-.1-4.476-.95-4.737C7.577.243 6.58 1.789 4.585 4.88m3.34 5.844L7.92 9.328H5.764c-1.109 0-1.792-.003-2.255-.068.202-.44.582-1.035 1.205-2.001l1.046-1.62c.993-1.538 1.674-2.589 2.214-3.245.076.645.098 1.571.102 2.882l.004 1.396h2.156c1.108 0 1.792.003 2.255.068-.202.44-.582 1.035-1.205 2.001l-1.046 1.62c-.993 1.538-1.674 2.589-2.214 3.245-.076-.645-.098-1.572-.102-2.882"
                fill="currentColor"
            />
        </g>
    </svg>
));
BoltOutlinedSize16Glyph.displayName = 'BoltOutlinedSize16Glyph';
